// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2I3Ro","header":"MessagesList_header__1Cfdv","chat":"MessagesList_chat__2vkbi"};